/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_2_WInputs */

const en_cp_cmp_2_w = /** @type {(inputs: Cp_Cmp_2_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For every team without selection, 4–6 h/week, your own lecturer as client; MBKM support documents for Campus Partners.`)
};

const id_cp_cmp_2_w = /** @type {(inputs: Cp_Cmp_2_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk semua tim tanpa seleksi, 4–6 jam/minggu, dosen sendiri sebagai klien; dokumen pendukung MBKM untuk Kampus Mitra.`)
};

/**
* | output |
* | --- |
* | "For every team without selection, 4–6 h/week, your own lecturer as client; MBKM support documents for Campus Partners." |
*
* @param {Cp_Cmp_2_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_2_w = /** @type {((inputs?: Cp_Cmp_2_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_2_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_2_w(inputs)
	return en_cp_cmp_2_w(inputs)
});